(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[144],{

/***/ 8273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CountUp": function() { return /* binding */ i; }
/* harmony export */ });
var t=function(){return t=Object.assign||function(t){for(var i,n=1,s=arguments.length;n<s;n++)for(var a in i=arguments[n])Object.prototype.hasOwnProperty.call(i,a)&&(t[a]=i[a]);return t},t.apply(this,arguments)},i=function(){function i(i,n,s){var a=this;this.endVal=n,this.options=s,this.version="2.8.0",this.defaults={startVal:0,decimalPlaces:0,duration:2,useEasing:!0,useGrouping:!0,useIndianSeparators:!1,smartEasingThreshold:999,smartEasingAmount:333,separator:",",decimal:".",prefix:"",suffix:"",enableScrollSpy:!1,scrollSpyDelay:200,scrollSpyOnce:!1},this.finalEndVal=null,this.useEasing=!0,this.countDown=!1,this.error="",this.startVal=0,this.paused=!0,this.once=!1,this.count=function(t){a.startTime||(a.startTime=t);var i=t-a.startTime;a.remaining=a.duration-i,a.useEasing?a.countDown?a.frameVal=a.startVal-a.easingFn(i,0,a.startVal-a.endVal,a.duration):a.frameVal=a.easingFn(i,a.startVal,a.endVal-a.startVal,a.duration):a.frameVal=a.startVal+(a.endVal-a.startVal)*(i/a.duration);var n=a.countDown?a.frameVal<a.endVal:a.frameVal>a.endVal;a.frameVal=n?a.endVal:a.frameVal,a.frameVal=Number(a.frameVal.toFixed(a.options.decimalPlaces)),a.printValue(a.frameVal),i<a.duration?a.rAF=requestAnimationFrame(a.count):null!==a.finalEndVal?a.update(a.finalEndVal):a.options.onCompleteCallback&&a.options.onCompleteCallback()},this.formatNumber=function(t){var i,n,s,e,o=t<0?"-":"";i=Math.abs(t).toFixed(a.options.decimalPlaces);var r=(i+="").split(".");if(n=r[0],s=r.length>1?a.options.decimal+r[1]:"",a.options.useGrouping){e="";for(var l=3,h=0,u=0,p=n.length;u<p;++u)a.options.useIndianSeparators&&4===u&&(l=2,h=1),0!==u&&h%l==0&&(e=a.options.separator+e),h++,e=n[p-u-1]+e;n=e}return a.options.numerals&&a.options.numerals.length&&(n=n.replace(/[0-9]/g,(function(t){return a.options.numerals[+t]})),s=s.replace(/[0-9]/g,(function(t){return a.options.numerals[+t]}))),o+a.options.prefix+n+s+a.options.suffix},this.easeOutExpo=function(t,i,n,s){return n*(1-Math.pow(2,-10*t/s))*1024/1023+i},this.options=t(t({},this.defaults),s),this.formattingFn=this.options.formattingFn?this.options.formattingFn:this.formatNumber,this.easingFn=this.options.easingFn?this.options.easingFn:this.easeOutExpo,this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.endVal=this.validateValue(n),this.options.decimalPlaces=Math.max(this.options.decimalPlaces),this.resetDuration(),this.options.separator=String(this.options.separator),this.useEasing=this.options.useEasing,""===this.options.separator&&(this.options.useGrouping=!1),this.el="string"==typeof i?document.getElementById(i):i,this.el?this.printValue(this.startVal):this.error="[CountUp] target is null or undefined","undefined"!=typeof window&&this.options.enableScrollSpy&&(this.error?console.error(this.error,i):(window.onScrollFns=window.onScrollFns||[],window.onScrollFns.push((function(){return a.handleScroll(a)})),window.onscroll=function(){window.onScrollFns.forEach((function(t){return t()}))},this.handleScroll(this)))}return i.prototype.handleScroll=function(t){if(t&&window&&!t.once){var i=window.innerHeight+window.scrollY,n=t.el.getBoundingClientRect(),s=n.top+window.pageYOffset,a=n.top+n.height+window.pageYOffset;a<i&&a>window.scrollY&&t.paused?(t.paused=!1,setTimeout((function(){return t.start()}),t.options.scrollSpyDelay),t.options.scrollSpyOnce&&(t.once=!0)):(window.scrollY>a||s>i)&&!t.paused&&t.reset()}},i.prototype.determineDirectionAndSmartEasing=function(){var t=this.finalEndVal?this.finalEndVal:this.endVal;this.countDown=this.startVal>t;var i=t-this.startVal;if(Math.abs(i)>this.options.smartEasingThreshold&&this.options.useEasing){this.finalEndVal=t;var n=this.countDown?1:-1;this.endVal=t+n*this.options.smartEasingAmount,this.duration=this.duration/2}else this.endVal=t,this.finalEndVal=null;null!==this.finalEndVal?this.useEasing=!1:this.useEasing=this.options.useEasing},i.prototype.start=function(t){this.error||(this.options.onStartCallback&&this.options.onStartCallback(),t&&(this.options.onCompleteCallback=t),this.duration>0?(this.determineDirectionAndSmartEasing(),this.paused=!1,this.rAF=requestAnimationFrame(this.count)):this.printValue(this.endVal))},i.prototype.pauseResume=function(){this.paused?(this.startTime=null,this.duration=this.remaining,this.startVal=this.frameVal,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count)):cancelAnimationFrame(this.rAF),this.paused=!this.paused},i.prototype.reset=function(){cancelAnimationFrame(this.rAF),this.paused=!0,this.resetDuration(),this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.printValue(this.startVal)},i.prototype.update=function(t){cancelAnimationFrame(this.rAF),this.startTime=null,this.endVal=this.validateValue(t),this.endVal!==this.frameVal&&(this.startVal=this.frameVal,null==this.finalEndVal&&this.resetDuration(),this.finalEndVal=null,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count))},i.prototype.printValue=function(t){var i;if(this.el){var n=this.formattingFn(t);if(null===(i=this.options.plugin)||void 0===i?void 0:i.render)this.options.plugin.render(this.el,n);else if("INPUT"===this.el.tagName)this.el.value=n;else"text"===this.el.tagName||"tspan"===this.el.tagName?this.el.textContent=n:this.el.innerHTML=n}},i.prototype.ensureNumber=function(t){return"number"==typeof t&&!isNaN(t)},i.prototype.validateValue=function(t){var i=Number(t);return this.ensureNumber(i)?i:(this.error="[CountUp] invalid start or end value: ".concat(t),null)},i.prototype.resetDuration=function(){this.startTime=null,this.duration=1e3*Number(this.options.duration),this.remaining=this.duration},i}();


/***/ }),

/***/ 10534:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en",
      function () {
        return __webpack_require__(96868);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68737);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25194);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18700);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94375);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99304);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2261);
/* harmony import */ var react_countup__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17857);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30552);
/* harmony import */ var _utils_useRequest__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54013);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25838);
/* harmony import */ var _utils_useDate__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(19902);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_14__);


















var Home = function(param) {
    var navDetail = param.navDetail;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), activeIndex = ref1[0], setActiveIndex = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoad = ref2[0], setIsLoad = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), data = ref3[0], setData = ref3[1];
    var request = (0,_utils_useRequest__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_14__.useRouter)();
    var chunkArray = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(arr, chunkSize) {
        var chunkedArray = [];
        var index = 0;
        while(index < arr.length){
            var end = Math.min(index + chunkSize, arr.length);
            chunkedArray.push(arr.slice(index, end));
            index = end;
        }
        return chunkedArray;
    }, []);
    var handleSlideChange = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(swiper) {
        setActiveIndex(swiper.activeIndex + 1);
    }, []);
    var getData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function() {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request.get("/home/index")
                    ];
                case 1:
                    data = _state.sent().data;
                    setData(data === null || data === void 0 ? void 0 : data.data);
                    setIsLoad(true);
                    return [
                        2
                    ];
            }
        });
    }), []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        getData();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().container) || ""),
        children: [
            (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_12__/* .getHead */ .c)(navDetail),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-c1e7ca4cfbf6fbd7" + " " + (classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().banner),
                    "banner"
                ]) || ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .Swiper */ .tq, {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().swiper),
                    modules: [
                        swiper_modules__WEBPACK_IMPORTED_MODULE_7__/* .Autoplay */ .pt
                    ],
                    spaceBetween: 0,
                    autoplay: true,
                    slidesPerView: 1,
                    children: (data === null || data === void 0 ? void 0 : data.banner_list) && (data === null || data === void 0 ? void 0 : data.banner_list.map(function(item) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .SwiperSlide */ .o5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: !!item.url ? item.url : "javascript:;",
                                target: !!item.url ? "_blank" : "_self",
                                className: "jsx-c1e7ca4cfbf6fbd7",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    style: {
                                        width: "100%"
                                    },
                                    loading: "lazy",
                                    src: item.image,
                                    alt: "",
                                    className: "jsx-c1e7ca4cfbf6fbd7"
                                })
                            })
                        }, item.id);
                    }))
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().bannerBtns) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://visitor.organic-festa.com/en/register",
                        className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().left) || ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-c1e7ca4cfbf6fbd7",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: "Apply to Visit"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: "Pre-register now and visit the exhibition for free"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        href: "https://exhibitor.organic-festa.com/en/apply",
                        className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().right) || ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-c1e7ca4cfbf6fbd7",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                            children: "Booth Application"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                            children: "Register online now and become an exhibitor"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    loading: "lazy",
                                    src: "/image/home-apply-icon.png",
                                    alt: "",
                                    className: "jsx-c1e7ca4cfbf6fbd7"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().intro) || ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "jsx-c1e7ca4cfbf6fbd7",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "jsx-c1e7ca4cfbf6fbd7",
                            children: "Organic Festa Asia"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-c1e7ca4cfbf6fbd7",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: "The exhibition is dedicated to bringing together global organic agriculture experts, brands, technological innovators and eco-pioneers, displaying the latest organic products, innovative technologies and sustainable solutions, advocating an organic sustainable lifestyle, creating business opportunities for exhibitors, promoting the development of organic industries in Asia and even the world, enhancing market awareness and acceptance, providing in-depth exchange opportunities for producers, distributors and consumers, and helping the future development of the organic market."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "/en/about/overview",
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: "View More"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().introLink) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        href: "https://exhibitor.organic-festa.com/en/login",
                        target: "_blank",
                        className: "jsx-c1e7ca4cfbf6fbd7",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                loading: "lazy",
                                src: "/image/organic.png",
                                alt: "",
                                className: "jsx-c1e7ca4cfbf6fbd7"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "jsx-c1e7ca4cfbf6fbd7",
                                children: "Exhibitor Center"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "jsx-c1e7ca4cfbf6fbd7",
                                children: "Green future, intelligent organic leadership, technology empowering new industrial ecology"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        href: "https://visitor.organic-festa.com/en/login",
                        target: "_blank",
                        className: "jsx-c1e7ca4cfbf6fbd7",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                loading: "lazy",
                                src: "/image/clover.png",
                                alt: "",
                                className: "jsx-c1e7ca4cfbf6fbd7"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "jsx-c1e7ca4cfbf6fbd7",
                                children: "Visitor Center"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "jsx-c1e7ca4cfbf6fbd7",
                                children: "Exciting exhibits invite you to appreciate, high-end forum inspires new ideas."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        href: "/en/contacts",
                        target: "_blank",
                        className: "jsx-c1e7ca4cfbf6fbd7",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                loading: "lazy",
                                src: "/image/earth.png",
                                alt: "",
                                className: "jsx-c1e7ca4cfbf6fbd7"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "jsx-c1e7ca4cfbf6fbd7",
                                children: "Contact Us"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "jsx-c1e7ca4cfbf6fbd7",
                                children: "Technology leads the green future, come and join us!"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().survey) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().left) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "jsx-c1e7ca4cfbf6fbd7",
                                children: "—— Overview"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                className: "jsx-c1e7ca4cfbf6fbd7",
                                children: [
                                    "Towards the 2025 Organic Industry Exhibition",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                        className: "jsx-c1e7ca4cfbf6fbd7"
                                    }),
                                    "Co draw a new green chapter"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "jsx-c1e7ca4cfbf6fbd7",
                                children: 'Organic Festa Asia is a professional platform jointly created by IFOAM - Organics Asia and Messe D\xfcsseldorf (Shanghai) Co., Ltd. It will be held at the Shanghai New International Expo Center from September 3-5, 2025, with the theme of "Sustainable Lifestyle in Organics", covering the entire organic industry chain.'
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-c1e7ca4cfbf6fbd7",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "https://online.organic-festa.com/en/online/exhibitor",
                                        className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().btn1) || ""),
                                        children: "Exhibitors & Products"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "",
                                        className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().btn2) || ""),
                                        children: "Business Matching"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().right) || ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            loading: "lazy",
                            src: "/image/home-video-bg.png",
                            alt: "",
                            className: "jsx-c1e7ca4cfbf6fbd7"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().introData) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: "jsx-c1e7ca4cfbf6fbd7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-c1e7ca4cfbf6fbd7",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                            end: 13000,
                                            duration: 1,
                                            enableScrollSpy: true
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                            children: "+"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: "Professionals"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-c1e7ca4cfbf6fbd7"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: "jsx-c1e7ca4cfbf6fbd7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-c1e7ca4cfbf6fbd7",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                            end: 12000,
                                            duration: 1,
                                            enableScrollSpy: true
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            style: {
                                                fontSize: "36px"
                                            },
                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                            children: "㎡"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: "Exhibition Area"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-c1e7ca4cfbf6fbd7"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        style: {
                            flex: "3"
                        },
                        className: "jsx-c1e7ca4cfbf6fbd7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-c1e7ca4cfbf6fbd7",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                            end: 300,
                                            duration: 1,
                                            enableScrollSpy: true
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                            children: "+"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: "Global Exhibitors"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-c1e7ca4cfbf6fbd7"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: "jsx-c1e7ca4cfbf6fbd7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-c1e7ca4cfbf6fbd7",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                            end: 30,
                                            duration: 1,
                                            enableScrollSpy: true
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                            children: "+"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: "Events"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-c1e7ca4cfbf6fbd7"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().partner) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "jsx-c1e7ca4cfbf6fbd7",
                        children: "——Partners"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "jsx-c1e7ca4cfbf6fbd7",
                        children: "Partners To Create An Organic Future"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .Swiper */ .tq, {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().swiper),
                        modules: [
                            swiper_modules__WEBPACK_IMPORTED_MODULE_7__/* .Autoplay */ .pt,
                            swiper_modules__WEBPACK_IMPORTED_MODULE_7__/* .Pagination */ .tl
                        ],
                        spaceBetween: 0,
                        autoplay: true,
                        pagination: {
                            clickable: true
                        },
                        slidesPerView: 1,
                        style: {
                            paddingBottom: "30px"
                        },
                        children: data.partner_list && ((ref = chunkArray(data.partner_list, 6)) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .SwiperSlide */ .o5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().brandList) || ""),
                                    children: item.map(function(child) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().item) || ""),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: child.link_cn ? child.link_cn : "javascript:;",
                                                    target: child.link_cn ? "_blank" : "_self",
                                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        loading: "lazy",
                                                        src: child.image,
                                                        alt: "",
                                                        className: "jsx-c1e7ca4cfbf6fbd7"
                                                    })
                                                }, child.id),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                                    children: child.title_en
                                                })
                                            ]
                                        });
                                    })
                                })
                            });
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().events) || ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "jsx-c1e7ca4cfbf6fbd7",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "jsx-c1e7ca4cfbf6fbd7",
                            children: "——Events & Forum"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                            className: "jsx-c1e7ca4cfbf6fbd7",
                            children: [
                                "Organic Future, Building Green Dreams Together",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "jsx-c1e7ca4cfbf6fbd7",
                                        children: "View More"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().eventList) || ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().left) || ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().top) || ""),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    loading: "lazy",
                                                    src: "/image/event-bg1.png",
                                                    alt: "",
                                                    className: "jsx-c1e7ca4cfbf6fbd7"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "jsx-c1e7ca4cfbf6fbd7" + " " + (classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                                                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().title1),
                                                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().arrow)
                                                    ]) || ""),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "jsx-c1e7ca4cfbf6fbd7",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "jsx-c1e7ca4cfbf6fbd7",
                                                                children: "Far away delicacies - A healthy and safe food platform that allows children to eat with peace of mind"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-c1e7ca4cfbf6fbd7",
                                                                children: "——The Rise of Organic Ecological Agriculture"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().bottom) || ""),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    loading: "lazy",
                                                    src: "/image/event-bg2.png",
                                                    alt: "",
                                                    className: "jsx-c1e7ca4cfbf6fbd7"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "jsx-c1e7ca4cfbf6fbd7" + " " + (classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                                                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().title2),
                                                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().arrow)
                                                    ]) || ""),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "jsx-c1e7ca4cfbf6fbd7",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "jsx-c1e7ca4cfbf6fbd7",
                                                                children: "Organic green food supporting technology, equipment and production"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-c1e7ca4cfbf6fbd7",
                                                                children: "——The Rise of Organic Ecological Agriculture"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().right) || ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().top) || ""),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-c1e7ca4cfbf6fbd7" + " " + (classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                                                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().title1),
                                                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().arrow)
                                                ]) || ""),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                                            children: "Interactive Talks on Agricultural Supply and Demand, Past and Present"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                                            children: "——The Rise of Organic Ecological Agriculture"
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().bottom) || ""),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    loading: "lazy",
                                                    src: "/image/event-bg3.png",
                                                    alt: "",
                                                    className: "jsx-c1e7ca4cfbf6fbd7"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "jsx-c1e7ca4cfbf6fbd7" + " " + (classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                                                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().title1),
                                                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().arrow)
                                                    ]) || ""),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "jsx-c1e7ca4cfbf6fbd7",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "jsx-c1e7ca4cfbf6fbd7",
                                                                children: "The Prospects and Development of Organic Products"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-c1e7ca4cfbf6fbd7",
                                                                children: "——The Rise of Organic Ecological Agriculture"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().comment) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "jsx-c1e7ca4cfbf6fbd7",
                        children: "——Exhibitor Evaluation"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-c1e7ca4cfbf6fbd7",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().left) || ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                        className: "jsx-c1e7ca4cfbf6fbd7",
                                        children: [
                                            "Organic Industry Exhibition",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                                className: "jsx-c1e7ca4cfbf6fbd7"
                                            }),
                                            "Inviting you to witness the green transformation!"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-c1e7ca4cfbf6fbd7",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_10__/* .Progress */ .Ex, {
                                                style: {
                                                    width: "60%"
                                                },
                                                stroke: "#0a4020",
                                                percent: activeIndex / 3 * 100
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "jsx-c1e7ca4cfbf6fbd7",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "jsx-c1e7ca4cfbf6fbd7",
                                                        children: activeIndex < 10 ? "0".concat(activeIndex) : activeIndex
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        style: {
                                                            margin: "0 5px"
                                                        },
                                                        className: "jsx-c1e7ca4cfbf6fbd7",
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        style: {
                                                            color: "#aaa"
                                                        },
                                                        className: "jsx-c1e7ca4cfbf6fbd7",
                                                        children: "03"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().right) || ""),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .Swiper */ .tq, {
                                    modules: [
                                        swiper_modules__WEBPACK_IMPORTED_MODULE_7__/* .Autoplay */ .pt
                                    ],
                                    spaceBetween: 0,
                                    autoplay: true,
                                    slidesPerView: 1,
                                    style: {
                                        height: "auto"
                                    },
                                    onSlideChange: function(swiper) {
                                        return handleSlideChange(swiper);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .SwiperSlide */ .o5, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                                    children: "Messe D\xfcsseldorf (Shanghai) Co., Ltd. will utilize its rich experience in exhibition organization and market layout in the Asian center, combined with the professional knowledge and industry influence of the International Federation of Organic Agriculture Asia (IFOAM Organics Asia), to jointly provide a high standard display and communication platform for the organic industry. This not only helps to enhance the market awareness and acceptance of organic products, but also provides more business opportunities and market expansion possibilities for participating companies."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().commentBottom) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().logo) || ""),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        loading: "lazy",
                                                                        src: "/image/logo1.png",
                                                                        alt: "",
                                                                        className: "jsx-c1e7ca4cfbf6fbd7"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                                                    children: [
                                                                        "Messe D\xfcsseldorf",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                                                            children: "Yan Gu  General Manager"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            loading: "lazy",
                                                            src: "/image/home-comment-icon.png",
                                                            alt: "",
                                                            className: "jsx-c1e7ca4cfbf6fbd7"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .SwiperSlide */ .o5, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                                    children: "Messe D\xfcsseldorf (Shanghai) Co., Ltd. will utilize its rich experience in exhibition organization and market layout in the Asian center, combined with the professional knowledge and industry influence of the International Federation of Organic Agriculture Asia (IFOAM Organics Asia), to jointly provide a high standard display and communication platform for the organic industry. This not only helps to enhance the market awareness and acceptance of organic products, but also provides more business opportunities and market expansion possibilities for participating companies."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().commentBottom) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().logo) || ""),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        loading: "lazy",
                                                                        src: "/image/logo1.png",
                                                                        alt: "",
                                                                        className: "jsx-c1e7ca4cfbf6fbd7"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                                                    children: [
                                                                        "Messe D\xfcsseldorf",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                                                            children: "Yan Gu  General Manager"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            loading: "lazy",
                                                            src: "/image/home-comment-icon.png",
                                                            alt: "",
                                                            className: "jsx-c1e7ca4cfbf6fbd7"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().photos) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        loading: "lazy",
                        src: "https://img.organic-festa.com/uploads/editor/20250424/93a499967e55b8f819cab82d3d222b9b.jpg",
                        alt: "",
                        className: "jsx-c1e7ca4cfbf6fbd7"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        loading: "lazy",
                        src: "https://img.organic-festa.com/uploads/editor/20250424/09517ae2bfc50de5aebfefbb2f09be65.jpg",
                        alt: "",
                        className: "jsx-c1e7ca4cfbf6fbd7"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        loading: "lazy",
                        src: "https://img.organic-festa.com/uploads/editor/20250424/a2d443b0b8754b03cf43627418123c95.jpg",
                        alt: "",
                        className: "jsx-c1e7ca4cfbf6fbd7"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        loading: "lazy",
                        src: "https://img.organic-festa.com/uploads/editor/20250424/87bdbaf43b5f27d325573c4749b97047.jpg",
                        alt: "",
                        className: "jsx-c1e7ca4cfbf6fbd7"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        loading: "lazy",
                        src: "https://img.organic-festa.com/uploads/editor/20250424/e34ba805b39cac3938456d278e52cbbc.jpg",
                        alt: "",
                        className: "jsx-c1e7ca4cfbf6fbd7"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        loading: "lazy",
                        src: "https://img.organic-festa.com/uploads/editor/20250424/701f29beb8ac0aa6bbc9c1607381d296.jpg",
                        alt: "",
                        className: "jsx-c1e7ca4cfbf6fbd7"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().news) || ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "jsx-c1e7ca4cfbf6fbd7",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "jsx-c1e7ca4cfbf6fbd7",
                            children: "——News Information"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                            className: "jsx-c1e7ca4cfbf6fbd7",
                            children: [
                                "Learn about the new information of the exhibition",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    onClick: function() {
                                        return router.push("/en/media/show");
                                    },
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "jsx-c1e7ca4cfbf6fbd7",
                                        children: "View More"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .Swiper */ .tq, {
                            modules: [
                                swiper_modules__WEBPACK_IMPORTED_MODULE_7__/* .Autoplay */ .pt
                            ],
                            autoplay: true,
                            breakpoints: {
                                0: {
                                    slidesPerView: 1
                                },
                                888: {
                                    slidesPerView: 3
                                }
                            },
                            loop: true,
                            spaceBetween: 30,
                            style: {
                                height: "369px"
                            },
                            children: (data === null || data === void 0 ? void 0 : data.news_list) && data.news_list.map(function(item) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .SwiperSlide */ .o5, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().item) || ""),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            href: item.url ? item.url : "/media/news_detail/".concat(item.id),
                                            target: "_blank",
                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().top) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                                                    children: item.publish_time ? Object.values((0,_utils_useDate__WEBPACK_IMPORTED_MODULE_13__/* .useDate */ .Y)(item.publish_time)).join(".") : ""
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().tag) || ""),
                                                                    children: item.category.name_en
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                                            children: item.title_en
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().bottom) || ""),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: item.image,
                                                        loading: "lazy",
                                                        alt: "",
                                                        className: "jsx-c1e7ca4cfbf6fbd7"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }, item.id);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().exhibitor) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().title) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "jsx-c1e7ca4cfbf6fbd7",
                                children: "——Recommended Exhibitors"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                className: "jsx-c1e7ca4cfbf6fbd7",
                                children: [
                                    "The organic industry is booming",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                        className: "jsx-c1e7ca4cfbf6fbd7"
                                    }),
                                    "Green development leads the trend",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-c1e7ca4cfbf6fbd7",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "jsx-c1e7ca4cfbf6fbd7",
                                            children: "View More"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .Swiper */ .tq, {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().logoSwiper),
                        modules: [
                            swiper_modules__WEBPACK_IMPORTED_MODULE_7__/* .Autoplay */ .pt
                        ],
                        spaceBetween: 30,
                        autoplay: true,
                        loop: true,
                        breakpoints: {
                            0: {
                                slidesPerView: 3
                            },
                            888: {
                                slidesPerView: 5
                            }
                        },
                        style: {
                            height: "auto"
                        },
                        children: (data === null || data === void 0 ? void 0 : data.recommended_exhibitor_list) && data.recommended_exhibitor_list.slice(0, Math.ceil(data.recommended_exhibitor_list.length / 2)).map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .SwiperSlide */ .o5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: item.url ? item.url : "javascript:;",
                                    target: item.url ? "_blank" : "_self",
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().logoBox) || ""),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            loading: "lazy",
                                            src: item.image,
                                            alt: "",
                                            className: "jsx-c1e7ca4cfbf6fbd7"
                                        })
                                    })
                                })
                            }, item.id);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .Swiper */ .tq, {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().swiper2),
                        modules: [
                            swiper_modules__WEBPACK_IMPORTED_MODULE_7__/* .Autoplay */ .pt
                        ],
                        breakpoints: {
                            0: {
                                slidesPerView: 3
                            },
                            888: {
                                slidesPerView: 5
                            }
                        },
                        autoplay: true,
                        loop: true,
                        style: {
                            height: "auto"
                        },
                        children: (data === null || data === void 0 ? void 0 : data.recommended_exhibitor_list) && data.recommended_exhibitor_list.slice(Math.ceil(data.recommended_exhibitor_list.length / 2)).map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .SwiperSlide */ .o5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    style: {
                                        marginRight: "30px",
                                        display: "block"
                                    },
                                    href: item.url ? item.url : "javascript:;",
                                    target: item.url ? "_blank" : "_self",
                                    className: "jsx-c1e7ca4cfbf6fbd7",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "jsx-c1e7ca4cfbf6fbd7" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().logoBox) || ""),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            loading: "lazy",
                                            src: item.image,
                                            alt: "",
                                            className: "jsx-c1e7ca4cfbf6fbd7"
                                        })
                                    })
                                })
                            }, item.id);
                        })
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "c1e7ca4cfbf6fbd7",
                children: ".swiper-pagination-bullet{width:40px;height:6px;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;background-color:#e3e3e3}.swiper-pagination-bullet{background-color:#393637}.swiper-pagination-bullet-active{background-color:#93d40b!important}"
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ }),

/***/ 19902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useDate; },
/* harmony export */   "q": function() { return /* binding */ DateRangeFormatter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useDate = function(date) {
    var time = new Date(String(date).length === 10 ? date * 1000 : date);
    return {
        year: time.getFullYear(),
        month: time.getMonth() + 1 < 10 ? "0" + (time.getMonth() + 1) : time.getMonth() + 1,
        day: time.getDate() < 10 ? "0" + time.getDate() : time.getDate()
    };
};
var DateRangeFormatter = function(start, end) {
    // 日期解析器（规避时区问题）
    var parseDate = function(dateStr) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dateStr.split(" "), 1), datePart = ref[0];
        var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(datePart.split("-").map(Number), 3), year = ref1[0], month = ref1[1], day = ref1[2];
        return new Date(year, month - 1, day);
    };
    // 日期格式化
    var formatDateObj = function(date) {
        return {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        };
    };
    // 主逻辑
    var generateRangeString = function() {
        var startDate = formatDateObj(parseDate(start));
        var endDate = formatDateObj(parseDate(end));
        if (start == end) {
            return "".concat(startDate.year, "年").concat(startDate.month, "月").concat(startDate.day, "日");
        }
        if (startDate.year === endDate.year) {
            if (startDate.month === endDate.month) {
                return "".concat(startDate.year, "年").concat(startDate.month, "月").concat(startDate.day, "-").concat(endDate.day, "日");
            }
            return "".concat(startDate.year, "年").concat(startDate.month, "月").concat(startDate.day, "日-").concat(endDate.month, "月").concat(endDate.day, "日");
        }
        return "".concat(startDate.year, "年").concat(startDate.month, "月").concat(startDate.day, "日-").concat(endDate.year, "年").concat(endDate.month, "月").concat(endDate.day, "日");
    };
    return generateRangeString();
};



/***/ }),

/***/ 25838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getHead; }
/* harmony export */ });
/* unused harmony export getServerSideProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48847);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);








var getServerSideProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(context) {
        var lang, data, newData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    lang = context.resolvedUrl.slice(0, 3) === "/en" ? "en" : "cn";
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_1___default().get("".concat(_utils__WEBPACK_IMPORTED_MODULE_5__/* .PRODDOMAIN */ .sC, "/home/menu_info"), {
                            params: {
                                pathinfo: (lang === "en" ? context.resolvedUrl.slice(3) : context.resolvedUrl) || "/"
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    newData = {};
                    if (data.code == 1) {
                        newData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data.data), {
                            seo_title: data.data["seo_title_".concat(lang)] || (lang === "cn" ? "2025亚洲有机产业展览会 | 有机产品与可持续发展盛会" : "Organic Festa Asia 2025 | Premier Exhibition for Organic Products and Sustainable Development"),
                            title: data.data["title_".concat(lang)],
                            content: data.data["content_".concat(lang)],
                            // brief: data.data[`brief_${lang}`],
                            seo_desc: data.data["seo_desc_".concat(lang)] || (lang === "cn" ? "亚洲有机产业展览会，有机产品展览，2025上海有机展，可持续发展，国际有机贸易平台" : "Organic Festa Asia, organic products exhibition, 2025 Shanghai organic expo, sustainable development, international organic trade platform"),
                            seo_keyword: data.data["seo_keyword_".concat(lang)] || (lang === "cn" ? "欢迎参加将于2025年9月3日至5日在上海举办的亚洲有机产业展览会。汇聚全球顶尖有机品牌、专业买家和行业专家，探索有机产品与可持续发展的最新趋势和商机。" : "Join us at the Organic Festa Asia 2025, taking place from September 3 to 5 in Shanghai. Connect with leading organic brands, professional buyers, and industry experts worldwide to explore the latest trends and opportunities in organic products and sustainable development.")
                        });
                    }
                    return [
                        2,
                        {
                            props: {
                                navDetail: newData || {}
                            }
                        }
                    ];
            }
        });
    });
    return function getServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var getHead = function(navDetail) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    navDetail === null || navDetail === void 0 ? void 0 : navDetail.seo_title,
                    " "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: navDetail === null || navDetail === void 0 ? void 0 : navDetail.seo_keyword
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: navDetail === null || navDetail === void 0 ? void 0 : navDetail.seo_desc
            })
        ]
    });
};



/***/ }),

/***/ 68737:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"en_container__voW3E","banner":"en_banner__ddzzM","bannerBtns":"en_bannerBtns__S1WdS","left":"en_left__dXRdp","right":"en_right__FDP7m","intro":"en_intro___ixno","introLink":"en_introLink__x4axd","survey":"en_survey__2z9aK","btn1":"en_btn1__17Qpv","btn2":"en_btn2__36eqo","introData":"en_introData__q4qtR","partner":"en_partner__5OJ0M","brandList":"en_brandList__Lu4b5","item":"en_item__i_F0T","events":"en_events__1CFEi","eventList":"en_eventList__SChiZ","arrow":"en_arrow__T0DIA","title1":"en_title1__tcJVF","top":"en_top__P2Kla","bottom":"en_bottom__24Lf7","title2":"en_title2__vqpoJ","comment":"en_comment___5_1u","commentBottom":"en_commentBottom__VYsqH","logo":"en_logo__2bu_W","photos":"en_photos__qg_LY","news":"en_news__7OtDx","tag":"en_tag__bsNnw","exhibitor":"en_exhibitor__KbrNQ","title":"en_title__KI_A3","logoSwiper":"en_logoSwiper__pfGkl","logoBox":"en_logoBox__G9dzI","moveUp":"en_moveUp___0P3p"};

/***/ }),

/***/ 17857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(67294);
var countup_js = __webpack_require__(8273);

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * Silence SSR Warnings.
 * Borrowed from Formik v2.1.1, Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? React.useLayoutEffect : React.useEffect;

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Create a stable reference to a callback which is updated after each render is committed.
 * Typed version borrowed from Formik v2.2.1. Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */
function useEventCallback(fn) {
  var ref = React.useRef(fn);

  // we copy a ref to the callback scoped to the current state/props on each render
  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current.apply(void 0, args);
  }, []);
}

var createCountUpInstance = function createCountUpInstance(el, props) {
  var decimal = props.decimal,
    decimals = props.decimals,
    duration = props.duration,
    easingFn = props.easingFn,
    end = props.end,
    formattingFn = props.formattingFn,
    numerals = props.numerals,
    prefix = props.prefix,
    separator = props.separator,
    start = props.start,
    suffix = props.suffix,
    useEasing = props.useEasing,
    useGrouping = props.useGrouping,
    useIndianSeparators = props.useIndianSeparators,
    enableScrollSpy = props.enableScrollSpy,
    scrollSpyDelay = props.scrollSpyDelay,
    scrollSpyOnce = props.scrollSpyOnce,
    plugin = props.plugin;
  return new countup_js.CountUp(el, end, {
    startVal: start,
    duration: duration,
    decimal: decimal,
    decimalPlaces: decimals,
    easingFn: easingFn,
    formattingFn: formattingFn,
    numerals: numerals,
    separator: separator,
    prefix: prefix,
    suffix: suffix,
    plugin: plugin,
    useEasing: useEasing,
    useIndianSeparators: useIndianSeparators,
    useGrouping: useGrouping,
    enableScrollSpy: enableScrollSpy,
    scrollSpyDelay: scrollSpyDelay,
    scrollSpyOnce: scrollSpyOnce
  });
};

var _excluded$1 = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"];
var DEFAULTS = {
  decimal: '.',
  separator: ',',
  delay: null,
  prefix: '',
  suffix: '',
  duration: 2,
  start: 0,
  decimals: 0,
  startOnMount: true,
  enableReinitialize: true,
  useEasing: true,
  useGrouping: true,
  useIndianSeparators: false
};
var useCountUp = function useCountUp(props) {
  var filteredProps = Object.fromEntries(Object.entries(props).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      value = _ref2[1];
    return value !== undefined;
  }));
  var _useMemo = React.useMemo(function () {
      return _objectSpread2(_objectSpread2({}, DEFAULTS), filteredProps);
    }, [props]),
    ref = _useMemo.ref,
    startOnMount = _useMemo.startOnMount,
    enableReinitialize = _useMemo.enableReinitialize,
    delay = _useMemo.delay,
    onEnd = _useMemo.onEnd,
    onStart = _useMemo.onStart,
    onPauseResume = _useMemo.onPauseResume,
    onReset = _useMemo.onReset,
    onUpdate = _useMemo.onUpdate,
    instanceProps = _objectWithoutProperties(_useMemo, _excluded$1);
  var countUpRef = React.useRef();
  var timerRef = React.useRef();
  var isInitializedRef = React.useRef(false);
  var createInstance = useEventCallback(function () {
    return createCountUpInstance(typeof ref === 'string' ? ref : ref.current, instanceProps);
  });
  var getCountUp = useEventCallback(function (recreate) {
    var countUp = countUpRef.current;
    if (countUp && !recreate) {
      return countUp;
    }
    var newCountUp = createInstance();
    countUpRef.current = newCountUp;
    return newCountUp;
  });
  var start = useEventCallback(function () {
    var run = function run() {
      return getCountUp(true).start(function () {
        onEnd === null || onEnd === void 0 || onEnd({
          pauseResume: pauseResume,
          reset: reset,
          start: restart,
          update: update
        });
      });
    };
    if (delay && delay > 0) {
      timerRef.current = setTimeout(run, delay * 1000);
    } else {
      run();
    }
    onStart === null || onStart === void 0 || onStart({
      pauseResume: pauseResume,
      reset: reset,
      update: update
    });
  });
  var pauseResume = useEventCallback(function () {
    getCountUp().pauseResume();
    onPauseResume === null || onPauseResume === void 0 || onPauseResume({
      reset: reset,
      start: restart,
      update: update
    });
  });
  var reset = useEventCallback(function () {
    // Quick fix for https://github.com/glennreyes/react-countup/issues/736 - should be investigated
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (getCountUp().el) {
      timerRef.current && clearTimeout(timerRef.current);
      getCountUp().reset();
      onReset === null || onReset === void 0 || onReset({
        pauseResume: pauseResume,
        start: restart,
        update: update
      });
    }
  });
  var update = useEventCallback(function (newEnd) {
    getCountUp().update(newEnd);
    onUpdate === null || onUpdate === void 0 || onUpdate({
      pauseResume: pauseResume,
      reset: reset,
      start: restart
    });
  });
  var restart = useEventCallback(function () {
    reset();
    start();
  });
  var maybeInitialize = useEventCallback(function (shouldReset) {
    if (startOnMount) {
      if (shouldReset) {
        reset();
      }
      start();
    }
  });
  React.useEffect(function () {
    if (!isInitializedRef.current) {
      isInitializedRef.current = true;
      maybeInitialize();
    } else if (enableReinitialize) {
      maybeInitialize(true);
    }
  }, [enableReinitialize, isInitializedRef, maybeInitialize, delay, props.start, props.suffix, props.prefix, props.duration, props.separator, props.decimals, props.decimal, props.formattingFn]);
  React.useEffect(function () {
    return function () {
      reset();
    };
  }, [reset]);
  return {
    start: restart,
    pauseResume: pauseResume,
    reset: reset,
    update: update,
    getCountUp: getCountUp
  };
};

var _excluded = ["className", "redraw", "containerProps", "children", "style"];
var CountUp = function CountUp(props) {
  var className = props.className,
    redraw = props.redraw,
    containerProps = props.containerProps,
    children = props.children,
    style = props.style,
    useCountUpProps = _objectWithoutProperties(props, _excluded);
  var containerRef = React.useRef(null);
  var isInitializedRef = React.useRef(false);
  var _useCountUp = useCountUp(_objectSpread2(_objectSpread2({}, useCountUpProps), {}, {
      ref: containerRef,
      startOnMount: typeof children !== 'function' || props.delay === 0,
      // component manually restarts
      enableReinitialize: false
    })),
    start = _useCountUp.start,
    reset = _useCountUp.reset,
    updateCountUp = _useCountUp.update,
    pauseResume = _useCountUp.pauseResume,
    getCountUp = _useCountUp.getCountUp;
  var restart = useEventCallback(function () {
    start();
  });
  var update = useEventCallback(function (end) {
    if (!props.preserveValue) {
      reset();
    }
    updateCountUp(end);
  });
  var initializeOnMount = useEventCallback(function () {
    if (typeof props.children === 'function') {
      // Warn when user didn't use containerRef at all
      if (!(containerRef.current instanceof Element)) {
        console.error("Couldn't find attached element to hook the CountUp instance into! Try to attach \"containerRef\" from the render prop to a an Element, eg. <span ref={containerRef} />.");
        return;
      }
    }

    // unlike the hook, the CountUp component initializes on mount
    getCountUp();
  });
  React.useEffect(function () {
    initializeOnMount();
  }, [initializeOnMount]);
  React.useEffect(function () {
    if (isInitializedRef.current) {
      update(props.end);
    }
  }, [props.end, update]);
  var redrawDependencies = redraw && props;

  // if props.redraw, call this effect on every props change
  React.useEffect(function () {
    if (redraw && isInitializedRef.current) {
      restart();
    }
  }, [restart, redraw, redrawDependencies]);

  // if not props.redraw, call this effect only when certain props are changed
  React.useEffect(function () {
    if (!redraw && isInitializedRef.current) {
      restart();
    }
  }, [restart, redraw, props.start, props.suffix, props.prefix, props.duration, props.separator, props.decimals, props.decimal, props.className, props.formattingFn]);
  React.useEffect(function () {
    isInitializedRef.current = true;
  }, []);
  if (typeof children === 'function') {
    // TypeScript forces functional components to return JSX.Element | null.
    return children({
      countUpRef: containerRef,
      start: start,
      reset: reset,
      update: updateCountUp,
      pauseResume: pauseResume,
      getCountUp: getCountUp
    });
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    className: className,
    ref: containerRef,
    style: style
  }, containerProps), typeof props.start !== 'undefined' ? getCountUp().formattingFn(props.start) : '');
};

exports.ZP = CountUp;
__webpack_unused_export__ = useCountUp;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [222,778,774,888,179], function() { return __webpack_exec__(10534); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);